import React from 'react';
import { ScanLine } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-2176" data-mp="3ggaovpzpm32t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2177" data-mp="32onjn0nshk7w">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-2178" data-mp="36pfshssr1n3n">
          <div className="col-span-1 md:col-span-2" data-id="element-2179" data-mp="36pzblcu4yhj9">
            <Link to="/" className="flex items-center space-x-2 mb-4 group" data-id="element-2180" data-mp="3ufa5cad2jbnw">
              <img src="https://cdn.magicpatterns.com/uploads/kYypn9DLGTyuEjc1d2cJka/intellieats_icon.webp" alt="IntelliEats icon" className="h-8 w-8 rounded-lg shadow-lg group-hover:shadow-brand-500/20 transition-all duration-300" data-id="element-2181" data-mp="3ud7i1y3avwmv" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-2182" data-mp="3qf9raqtvt2hd">
                Intelli<span className="text-brand-500" data-id="element-2183" data-mp="29xvqkc20tbos">Eats</span>
              </span>
            </Link>
            <p className="text-sm max-w-xs leading-relaxed" data-id="element-2184" data-mp="2ezl4bzgmo3gk">
              Empowering you to make healthier food choices through intelligent
              ingredient analysis. Scan, detect, and eat smarter.
            </p>
          </div>

          <div data-id="element-2185" data-mp="3v7ggw4mssibe">
            <h3 className="text-white font-bold mb-4" data-id="element-2186" data-mp="3v7zw3dl2cslq">Product</h3>
            <ul className="space-y-2 text-sm" data-id="element-2187" data-mp="3q8mzw28ay96h">
              <li data-id="element-2188" data-mp="3q7u1bojhypzf">
                <a href="/#how-it-works" className="hover:text-brand-400 transition-colors" data-id="element-2189" data-mp="3q7bvq1ay2zeu">
                  How It Works
                </a>
              </li>
              <li data-id="element-2190" data-mp="31up7hdvubpd">
                <a href="/#features" className="hover:text-brand-400 transition-colors" data-id="element-2191" data-mp="hstrybs1e611">
                  Features
                </a>
              </li>
              <li data-id="element-2192" data-mp="qt8fziwdxz88">
                <Link to="/blog" className="hover:text-brand-400 transition-colors" data-id="element-2193" data-mp="qsqfub6lr0v1">
                  Blog
                </Link>
              </li>
              <li data-id="element-2194" data-mp="tw5xq4ifnmlo">
                <a href="/#download" className="hover:text-brand-400 transition-colors" data-id="element-2195" data-mp="two3brqzjd69">
                  Download
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-2196" data-mp="18k0qtm0crsza">
            <h3 className="text-white font-bold mb-4" data-id="element-2197" data-mp="18jr3652s5xwr">Legal</h3>
            <ul className="space-y-2 text-sm" data-id="element-2198" data-mp="18m3sx4es5ckd">
              <li data-id="element-2199" data-mp="1cmdwkaf3nqw2">
                <Link to="/privacy" className="hover:text-brand-400 transition-colors" data-id="element-2200" data-mp="1ckt2sn0m0bz9">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-2201" data-mp="1mkjwwnl9coyt">
                <Link to="/terms" className="hover:text-brand-400 transition-colors" data-id="element-2202" data-mp="1mhxpqp2a4bh4">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-2203" data-mp="3ta8c1ohfn9dm">
                <Link to="/editorial-policy" className="hover:text-brand-400 transition-colors" data-id="element-2204" data-mp="3t9q805oj3qv5">
                  Editorial Policy
                </Link>
              </li>
              <li data-id="element-2205" data-mp="25nlrf11390y4">
                <Link to="/contact" className="hover:text-brand-400 transition-colors" data-id="element-2206" data-mp="25n3yad9q32uf">
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-2207" data-mp="2te99gf4px6ye">
          <p data-id="element-2208" data-mp="2pcw5kal6rdu4">© {new Date().getFullYear()} IntelliEats. All rights reserved.</p>
          <p className="mt-2 md:mt-0" data-id="element-2209" data-mp="2kc8ghugip72j">Developed by IntelliEats Team</p>
        </div>
      </div>
    </footer>;
}